import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    wrapper: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      width: "100%"
    },
    header: {
      cursor: "pointer",
      padding: "0.8rem 2.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem",
        fontSize: "18px"
      }
    },
    container: {},
    searchBox: {
      "& .MuiFormControl-root": {
        height: "36px"
      },
      margin: 0,
      width: "100%"
    },
    textOverdue: {
      placeSelf: "center"
    },
    leftCheckbox: {
      marginLeft: 0
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800],
        display: "flex"
      }
    },
    colorInfo: {
      color: theme.palette.grey[700]
    },
    colorSuccess: {
      color: theme.palette.success.main
    },
    colorError: {
      color: theme.palette.error.light
    },
    radioLine: {
      flexDirection: "row",
      "& .MuiFormControlLabel-root": {
        height: 40
      },
      "& .MuiFormControl-root": {
        flex: 1
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem"
      }
    },
    inputHalf: {
      "& .MuiAutocomplete-root": {
        width: "50%"
      }
    },
    lineRangeDate: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      justifyContent: "space-between"
    },
    info: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center"
    },
    icon: {
      marginRight: "1.1rem"
    },
    divider: {
      padding: "0 2.4rem"
    },
    bottomBar: {
      padding: "2.4rem 2.4rem 2.4rem 0",
      display: "flex",
      justifyContent: "space-between"
    },
    actionButton: {
      width: "132px",
      fontSize: "16px",
      height: "40px"
    },
    flex: {
      display: "flex"
    },
    disableBtn: {
      "& svg path": {
        stroke: "#CCCCCC"
      }
    },
    overdueBox: {
      paddingBottom: "0 !important"
    },
    circleIcon: {
      width: "12px",
      marginRight: "0.8rem"
    }
  }),
  {
    name: "LogChange"
  }
);

export default useStyles;
